import styled from "styled-components";

export const Bar = styled.div<{ percent: number }>`
  height: 3px;
  background-color: ${({ theme }) => theme.colors.brand[50]};
  border-radius: ${({ theme }) => theme.borders.radius.s};
  box-shadow: 0 8px 32px 0 rgba(254, 43, 143, 0.16);
  width: ${({ percent }) => Math.min(Math.max(percent, 0), 100)}%;
  z-index: 1;
`;
